var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDlpIcon = function SvgDlpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 54,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dlpIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    y: 9,
    stroke: "#1A2550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    rx: 18,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M18.054 18.938c1.593 0 2.863 0 3.858.132 1.027.137 1.872.426 2.54 1.087.67.662.963 1.5 1.102 2.52.134.986.134 2.244.134 3.82v.108c0 1.576 0 2.834-.134 3.82-.139 1.02-.433 1.857-1.102 2.52a3.3 3.3 0 0 1-.662.507c-.298.175-.668.04-.842-.259-.228-.393-.009-.883.343-1.17q.07-.057.13-.119c.35-.345.566-.822.681-1.677.12-.876.122-2.033.122-3.676 0-.651-.001-1.227-.01-1.738-.002-.206-.004-.309-.07-.373-.065-.065-.169-.065-.375-.065H12.23c-.206 0-.31 0-.376.064-.065.065-.067.168-.07.373-.008.512-.009 1.087-.009 1.739 0 1.643.002 2.8.122 3.677.116.854.331 1.33.68 1.676q.063.062.131.119c.352.287.571.777.343 1.17-.174.299-.544.434-.842.26a3.3 3.3 0 0 1-.662-.509c-.67-.662-.963-1.5-1.102-2.52-.134-.985-.133-2.243-.133-3.818v-.11c0-1.575 0-2.833.133-3.82.139-1.018.433-1.857 1.102-2.519.668-.661 1.513-.95 2.54-1.087.995-.132 2.265-.133 3.858-.133zm-3.728 1.968a.75.75 0 0 0-.747.75c0 .415.335.75.747.75h.006a.75.75 0 0 0 .747-.75.75.75 0 0 0-.747-.75zm3 0a.75.75 0 0 0-.747.75c0 .415.335.75.747.75h.006a.75.75 0 0 0 .747-.75.75.75 0 0 0-.747-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767C96",
    d: "M16.366 27.617c.44-.216.972-.43 1.633-.43.66 0 1.193.214 1.632.43.146.072.274.139.392.2.265.14.477.25.72.325l.017.004c.152.047.292.089.4.13.094.034.265.101.396.24a.9.9 0 0 1 .204.365c.027.09.047.194.064.283l.003.017c.465 2.45-.558 4.808-3.062 5.719l-.02.006c-.23.084-.428.157-.745.157s-.516-.073-.746-.157l-.019-.006c-2.504-.911-3.529-3.27-3.064-5.72l.004-.016c.016-.089.036-.193.063-.283a.9.9 0 0 1 .204-.365c.132-.139.302-.206.396-.24.109-.041.248-.083.4-.13l.017-.005c.243-.073.455-.184.72-.323q.175-.094.391-.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "dlpIcon_svg__a",
    width: 91.429,
    height: 91.429,
    x: -27.714,
    y: -9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "hard-light",
    result: "effect1_dropShadow_10029_196701"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10029_196701",
    result: "shape"
  })))));
};
export default SvgDlpIcon;